import React from 'react'

export default props => (
  <svg viewBox="0 0 48 48" style={{ background: '#017cb7' }} {...props}>
    <path
      fill="#fff"
      d="M11.715 8.002c-2.25 0-3.713 1.6-3.713 3.689 0 2.05 1.426 3.688 3.626 3.688h.05c2.288 0 3.713-1.638 3.713-3.688-.05-2.1-1.425-3.69-3.676-3.69zM32.083 18.13c-3.639 0-5.201 2.05-6.201 3.476V18.63h-6.877v21.38h6.877V27.832c0-.625.05-1.238.237-1.688.5-1.25 1.626-2.538 3.526-2.538 2.488 0 3.489 1.913 3.489 4.714v11.69h6.876V27.52c0-6.414-3.413-9.39-7.927-9.39zm-24.081.5v21.38h6.877V18.63z"
    />
  </svg>
)
